//

const lendingMixin = {
  methods: {
    async calcNewLendingBalance() {
      let newBalance = 0;
      let lendingTotal = Number(this.rmCamma(this.lendingTotal))
      if (this.model.type === 'rec') {
        if (this.formState === 'add') {
          newBalance = this.balance.current - lendingTotal
        } else { //edit
          newBalance = this.balance.current + this.prevBalance - lendingTotal
        }
      } else if (this.model.type === 'pay') {
        if (this.formState === 'add') {
          newBalance = this.balance.current + lendingTotal
        } else { //edit
          newBalance = this.balance.current - this.prevBalance + lendingTotal
        }
      }
      this.balance.new = newBalance
      //
    },
    valueBlur(item) {
      // console.log(item);
      if (item && item.lending_value && this.balance.current !== 0) {
        let balance = 0
        if (this.formStatus === 'add') {
          balance = Math.abs(this.balance.current)
        } else { //edit
          balance = Math.abs(this.balance.current) + Math.abs(this.prevBalance)
        }
        let difference = Math.abs(balance - item.lending_value * item.n)
        if (difference < 0.001) {
          if ((this.model.type === 'rec' && this.balance.current > 0) || (this.model.type === 'pay' && this.balance.current < 0)) {
            item.lending_value = Math.abs(balance) / item.n
          }
        }
      }
    },
  }
}

export default lendingMixin
